var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4317 5.92399L18.3256 5.36534C18.3308 5.40955 18.3334 5.45448 18.3334 5.49999V15.5C18.3334 16.1405 17.8073 16.6667 17.1667 16.6667H3.83341C3.19289 16.6667 2.66675 16.1405 2.66675 15.5V5.49999C2.66675 5.45448 2.6694 5.40955 2.67457 5.36534L3.56842 5.92399L10.2351 10.0907L10.5001 10.2563L10.7651 10.0907L17.4317 5.92399ZM18.2197 4.99999H17.1667H3.83341H2.78045C2.96892 4.60705 3.37141 4.33333 3.83341 4.33333H17.1667C17.6287 4.33333 18.0312 4.60705 18.2197 4.99999ZM17.1667 16H17.6667V15.5V7.16666V6.26454L16.9017 6.74266L10.5001 10.7437L4.09841 6.74266L3.33341 6.26454V7.16666V15.5V16H3.83341H17.1667Z",
    fill: "#787E7D",
    stroke: "#787E7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8f4dea0320a3f910c5a9f3c5ba9b5ba7.svg";
export { ForwardRef as ReactComponent };